import { Component } from '@angular/core';
import { PageContainerComponent } from '@unity/layouts/page-container/page-container.component';
import { ActionSharedComponent } from '@unity/shared/composed/action-shared/action-shared.component';
import { GridFormTemplateSharedComponent } from '@unity/shared/grid-form-template-shared/grid-form-template-shared.component';
import { QuickActions } from '@unity/utils/quick-actions';

@Component({
  selector: 'unity-list-form-template-page',
  imports: [PageContainerComponent, GridFormTemplateSharedComponent, ActionSharedComponent],
  templateUrl: './list-form-template-page.component.html',
  styleUrl: './list-form-template-page.component.scss',
})
export class ListFormTemplatePageComponent {
  protected $contentHeader = () => 'Form Templates';
  protected createTemplateAction = QuickActions.CreateFormTemplate;
  protected returnToDashboardAction = QuickActions.ReturnToDashboard;
}
